// extracted by mini-css-extract-plugin
export default {"infologCollapse":"expedition-service_infologCollapse__HIQ6S"};